import ReportServices from "@/services/ReportServices.js";

export default {
  getSalesInvoiceTotal: ReportServices.getSalesInvoiceTotal,
  getProfitLossTotal: ReportServices.getProfitLossTotal
}